import { render, staticRenderFns } from "./NewGoodsMsg.vue?vue&type=template&id=7a4a8acc&scoped=true"
import script from "./NewGoodsMsg.vue?vue&type=script&lang=js"
export * from "./NewGoodsMsg.vue?vue&type=script&lang=js"
import style0 from "./NewGoodsMsg.vue?vue&type=style&index=0&id=7a4a8acc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4a8acc",
  null
  
)

export default component.exports